// aws
import config from '../config';
import Request from './request';

const { aws: { api: { invokeUrl } } } = config;

export const getJobApplications = (pointer, limit) => Request.get(`${invokeUrl}/admin/jobApplications?limit=${limit}&pointer=${pointer}`, true);

export const updateJobApplication = (id, body) => Request.patch(`${invokeUrl}/admin/jobApplications/${encodeURIComponent(id)}`, body, true);

// eslint-disable-next-line import/prefer-default-export
export const cancelRejectionEmail = (id) => Request.post(`${invokeUrl}/admin/jobApplications/${encodeURIComponent(id)}/cancel-rejection-email`, {}, true);

export const createJobApplicationAdmin = (body) => Request.post(`${invokeUrl}/admin/jobApplications`, body, true);

export const deleteJobApplication = (id) => Request.delete(`${invokeUrl}/admin/jobApplications/${encodeURIComponent(id)}`, true);
